<template>
  <Layout ref="main">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="card_section">
          <div class="card-title p-3 py-2 border-bottom">
            <div class="d-lg-flex align-items-center">
              <div class="me-2 d-inline-block">
                <i class="bi bi-arrow-up-circle display-6 text-primary"></i>
              </div>
              <div class="mb-2 mb-lg-0 d-inline-block">
                <h4 class="fw-medium font-size-20 text-dark mb-0">
                  {{ title }}
                </h4>
              </div>

              <div class="ms-auto">
                <!-- <button
                  class="btn btn-outline-info fw-medium me-2"
                  @click="$refs.modalFunc2.showModal()"
                >
                  <i class="uil uil-plus font-size-16 me-1"></i> Import Payout
                </button> -->
                <button
                  class="btn btn-outline-info fw-medium me-2"
                  v-if="account_type=='admin' && create_modify_permission && (accessUsername=='jey' || accessUsername=='bryan' || accessUsername=='ian')"
                  @click="$refs.modalFunc.showModal()"
                >
                  <i class="uil uil-plus font-size-16 me-1"></i> Make a Payout
                </button>
                <button class="btn btn-outline-info fw-medium" @click="handlePageChange(currentPage)">
                  <i class="uil uil-redo font-size-16 me-1"></i> Refresh
                </button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-4 mb-3">
                <label class="form-label mb-1">Merchant Contract</label>
                <multiselect
                  ref="select"
                  v-model="selectedmerchantContract"
                  :options="merchantContract"
                  label="account_name"
                  placeholder="Select"
                  :close-on-select="true"
                  :allow-empty="false"
                  deselect-label=""
                  :show-on-select="true"
                  :disabled="disabled"
                  @open="isOpen = true"
                  @close="isOpen = false"
                  @input="handlePageChange(1)"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span v-if="props.option.contract_id !== ''">
                      <span
                        v-if="props.option.contract_status == 'unavailable'"
                        class="text-warning me-1"
                        >&#9679;</span
                      >
                      <span
                        v-else-if="props.option.contract_status == 'available'"
                        class="text-success me-1"
                        >&#9679;</span
                      >
                      <span class="option__title">
                        {{ props.option.account_name }}:
                        {{ props.option.contract_name }}
                      </span>
                    </span>
                    <span v-else>{{ props.option.contract_name }} </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <span v-if="props.option.contract_id !== ''">
                      <span
                        v-if="props.option.contract_status == 'unavailable'"
                        class="text-warning me-1"
                        >&#9679;</span
                      >
                      <span
                        v-else-if="props.option.contract_status == 'available'"
                        class="text-success me-1"
                        >&#9679;</span
                      >
                      <span class="option__title">
                        {{ props.option.account_name }}:
                        {{ props.option.contract_name }}
                      </span>
                    </span>
                    <span v-else>{{ props.option.contract_name }}</span>
                  </template>
                  <span slot="noResult">Oops! No Contract found. </span>
                </multiselect>
              </div>
              <div class="col-12 col-md-8">
                <div class="row">
                  <div class="col-12 col-md-4 px-md-1 mb-3">
                    <label class="form-label mb-1">Processed By</label>
                    <multiselect
                      v-model="selectedUsers"
                      :options="usersList"
                      label="name"
                      class=""
                      placeholder="Select"
                      :close-on-select="true"
                      :allow-empty="false"
                      deselect-label=""
                      select-label=""
                      :show-on-select="true"
                      :disabled="disabled"
                      @input="handlePageChange(1)"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span v-if="props.option.username !== ''">
                          <span class="option__title">{{
                            props.option.name
                          }}</span>
                        </span>
                      </template>

                      <template slot="option" slot-scope="props">
                        <span v-if="props.option.username !== ''">
                          {{ props.option.name }}
                        </span>
                      </template>
                      <span slot="noResult">Oops! No user found. </span>
                    </multiselect>
                  </div>
                  <div class="col-12 col-md-4 px-md-1 mb-3">
                    <label class="form-label mb-1">Status</label>
                    <select
                      class="form-select pe-5 font-size-13"
                      id="1"
                      v-model="selectedStatus"
                      @change="handlePageChange(1)"
                      :disabled="disabled"
                    >
                      <option value="">All Status</option>
                      <option value="complete">Completed</option>
                      <option value="rejected">Rejected</option>
                      <option value="pending">Pending</option>
                      <option value="reserved">Reserved</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-4 px-md-1 mb-3">
                    <label class="form-label mb-1">Country</label>
                    <multiselect
                      v-model="selectedCountry"
                      :options="countryList"
                      label="name"
                      class=""
                      placeholder="Select"
                      :close-on-select="true"
                      :allow-empty="false"
                      deselect-label=""
                      select-label=""
                      :show-on-select="true"
                      :disabled="disabled"
                      @input="countryChanged"
                    >
                      <span slot="noResult">Oops! No Country found. </span>
                    </multiselect>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg mb-3">
                <label class="form-label mb-1">Payout Id</label>
                <div>
                  <input
                    type="text"
                    placeholder="Payout Id"
                    class="form-control"
                    :disabled="disabled"
                    v-model.trim="searchPayoutId"
                    @keyup.enter="search()" 
                  />
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg mb-3">
                <label class="form-label mb-1">Reference No.</label>
                <div>
                  <input
                    type="text"
                    placeholder="Reference No."
                    class="form-control"
                    :disabled="disabled"
                    v-model.trim="searchReferenceNo"
                    @keyup.enter="search()" 
                  />
                </div>
              </div>
              <div class="col-12 col-md mb-3">
                <label class="form-label mb-1">Transaction ID</label>
                <div>
                  <input
                    type="text"
                    placeholder="Transaction ID"
                    class="form-control"
                    :disabled="disabled"
                    v-model.trim="searchTransactionId"
                    @keyup.enter="search()" 
                  />
                </div>
              </div>
              <div class="col-12 col-md mb-3">
                <label class="form-label mb-1">Amount</label>
                <div>
                  <input
                    type="tel"
                    @input="inputNumberOnly($event, 'searchAmount')"
                    placeholder="Amount"
                    class="form-control"
                    :disabled="disabled"
                    v-model.trim="searchAmount"
                    @keyup.enter="search()" 
                  />
                </div>
              </div>
              <div class="col-12 col-md-auto text-md-end mb-3 mb-lg-0">
                <label class="form-label mb-1 d-md-block d-none">&nbsp;</label>
                <div class="d-flex w-100">
                  <button
                    class="btn btn-light col-auto mb-0 me-2 text-nowrap d-grid"
                    type="button"
                    :disabled="disabled"
                    @click="clear()"
                  >
                    <span><i class="uil-redo me-1"></i> Clear</span>
                  </button>
                  <button
                    class="btn btn-info text-white me-0 text-nowrap d-grid"
                    type="button"
                    :disabled="disabled"
                    @click="search()"
                  >
                    <span><i class="uil-search me-1"></i> Search</span>
                  </button>
                </div>
              </div>
              <div class="col-12 m-0 p-0"></div>
              <div class="col-12 col-lg-12 col-xl">
                <label class="form-label mb-1">Filter By</label>
                <div class="input-group mb-3">
                  <select class="form-select pe-5" v-model="filterType">
                    <option value="created_date">Created Date</option>
                    <option value="updated_date">Updated Date</option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md col-xl mb-0">
                <label class="form-label mb-1">Date Range</label>
                <date-picker
                  v-model="date_range"
                  type="date"
                  range
                  value-type="format"
                  format="YYYY-MM-DD"
                  placeholder="Select Date Range"
                  :disabled="disable_date"
                  :disabled-date="notBeforeToday"
                  :clearable="false"
                  :editable="false"
                  :shortcuts="shortcuts"
                  class="mb-3"
                ></date-picker>
                <!-- 
                  @change="DateChanged()" -->
              </div>

              <div class="col-12 col-md-auto col-xl-auto">
                <label class="form-label mb-1 d-md-block d-none">&nbsp;</label>
                <div class="row">
                  <div class="col-6 pe-1 col-auto d-grid">
                    <button
                      class="btn btn-light mb-3 text-nowrap"
                      type="button"
                      :disabled="disabled"
                      @click="clear()"
                    >
                      <i class="uil-redo me-1"></i> Clear
                    </button>
                  </div>
                  <div class="col-6 ps-1 col-auto d-grid">
                    <button
                      class="btn btn-info text-white mb-3 text-nowrap"
                      type="button"
                      :disabled="disabled"
                      @click="search()"
                    >
                      <i class="uil-search me-1"></i> Search
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl">
                <div class="float-end">
                  <div class="mb-3 ml-auto d-none">
                    <b-button
                      type="submit"
                      variant="info"
                      @click="exportData()"
                      :disabled="disableExport"
                    >
                      <i class="uil-file-export me-1"></i>
                      Export
                      <div
                        class="spinner-border spinner-border-sm text-white"
                        v-if="loadingButton"
                        role="status"
                      ></div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4 mb-3">
                <div
                  class="d-md-flex justify-content-between bg-light text-info p-3 rounded"
                >
                  <div class="fw-medium">Total Payout</div>
                  <div class="fw-medium" v-if="returnPaidTotal">
                    {{ convertCurrencyFormat(returnPaidTotal, false) || 0 }}
                  </div>
                  <div class="fw-medium" v-else>0</div>
                </div>
              </div>
              <div class="col-12 col-md-4 mb-3">
                <div
                  class="d-md-flex justify-content-between bg-light text-primary p-3 rounded"
                >
                  <div class="fw-medium">Payout Process Completed</div>
                  <div class="fw-medium" v-if="returnPayoutProcessed">
                    {{ returnPayoutProcessed || 0 }}
                  </div>
                  <div class="fw-medium" v-else>0</div>
                </div>
              </div>
            </div>
            <div
              class="table-responsive text-nowrap font-size-13 position-relative custom-table"
            >
              <table
                id="freeze"
                class="table mt-2 mb-0 align-middle min-width-760"
                :class="{ 'table-hover': returnData.length > 0 }"
              >
                <thead class="text-uppercase">
                  <tr>
                    <th>Payout Id<br>Initiator</th>
                    <th>Reference No.<br />Merchant Item ID</th>
                    <th>Created Date<br />Updated Date</th>
                    <th>Merchant<br />Contract</th>
                    <!-- <th v-if="account_type == 'admin'">
                      Group / Method<br />Callback Data
                    </th> -->
                    <th>Receiving Bank<br />Beneficiary Name/Acc No.</th>
                    <th>Amount</th>
                    <th>Total Charges</th>
                    <th>Amount Deducted</th>
                    <th>Trx. ID<br />Trx Receipt</th>
                    <th>Status</th>
                    <th v-if="account_type == 'admin'">Processed By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!returnData.length && !loading">
                    <td
                      :colspan="account_type == 'admin' ? 13 : 11"
                      height="300"
                      class="text-center text-muted"
                    >
                      <i class="bi bi-arrow-up-circle me-1"></i> No Data
                      Available
                    </td>
                  </tr>
                  <tr v-if="loading">
                    <td
                      :colspan="account_type == 'admin' ? 13 : 11"
                      class="text-center text-muted"
                      height="400"
                    >
                      <div
                        class="spinner-border text-secondary my-2"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                      <br />
                      <div>Loading...</div>
                    </td>
                  </tr>

                  <tr v-for="(value, index) in returnData" :key="index">
                    <td>
                      <a href="javascript:void(0)" @click="clickExtraInfo(`Payout Detail #${value.payout_id }`, value)"
                      :title="`${value.payout_id}`">
                        {{ value.payout_id }}
                      </a>
                     <br>
                      <span class="badge bg-soft-purple font-size-13 mt-1 text-capitalize">  {{ value.initiator }} </span>
                    </td>
                    <td>
                      {{ value.reference_no || '-' }}
                      <br />
                      {{ value.merchant_item_id|| '-'  }}
                    </td>
                    <td>{{ value.created_at }}<br />{{ value.updated_at || '-' }}</td>
                    <td>
                      <div v-if="account_type == 'admin'">
                        <router-link
                          :to="{
                            name: 'merchants',
                            params: { id: value.upline_db_code },
                          }"
                          >#{{ value.merchant_info.merchant_id }}
                          {{ value.merchant_info.merchant_name }}</router-link
                        >
                      </div>
                      <div v-else>
                        #{{ value.merchant_info.merchant_id }}
                        {{ value.merchant_info.merchant_name }}
                      </div>

                      <router-link
                        :to="{
                          name: 'contract ledger with id',
                          params: {
                            resellerid: 'all',
                            id: value.merchant_info.merchant_contract,
                          },
                        }"
                        >{{ value.merchant_info.merchant_contract }}:
                        {{ value.merchant_info.merchant_contract_name }}
                      </router-link>

                    </td>
                    <!-- <td v-if="account_type == 'admin'">
                      <div v-if="value.pg_info.pg_name">
                        <div class="fw-medium" v-if="value.pg_info.pg_name">
                          {{ value.pg_info.pg_name }}
                        </div>
                        <button
                          class="btn btn-sm btn-outline-info"
                          @click="
                            clickExtraInfo(
                              `${value.pg_info.pg_name} - Callback Data`,
                              value.pg_info
                            )
                          "
                        >
                          Callback Data
                        </button>
                      </div>
                      <div v-else class="">-</div>
                      
                    </td> -->
                    <td>
                      <div class="fw-medium text-dark">
                        {{ value.receiving_bank }}
                      </div>
                      <div v-if="value.receiving_bank">
                        {{ value.receiver_account_name }}<br />{{
                          value.receiver_account_number
                        }}
                      </div>
                      <div v-else>-</div>
                    </td>
                    <td>
                      {{ value.payout_currency }}
                      <span v-if="value.payout_amount">{{ convertCurrencyFormat(value.payout_amount,true) }}</span>
                    </td>
                    <td>
                      {{ value.payout_currency }}
                      <span v-if="value.payout_total_charges">{{ convertCurrencyFormat(value.payout_total_charges,true) }}
                      <span class="text-muted font-size-12 d-block">  {{ value.payout_rate }}% + {{ value.payout_currency }}  {{ value.payout_extra_charges }}</span>
                      </span>
                    </td>
                    <td>
                      {{ value.payout_currency }} 
                      <span v-if="value.amount_deducted">{{ convertCurrencyFormat(value.amount_deducted,true) }}</span>
                    </td>
                    <td>
                      {{ value.transaction_id || "-" }}
                      <div v-if="value.transaction_receipt.length" class="mb-1">
                        <div v-for="(v, i) in value.transaction_receipt" :key="i">
                          <a
                            v-if="v !== ''"
                            :href="v"
                            target="_blank"
                            title="View Receipt"
                            ><i
                              class="bi bi-receipt font-size-16 text-primary"
                            ></i>
                            View Receipt ({{ i + 1 }})</a
                          >
                        </div>
                      </div>
                      <div v-else>-</div>
                      <a href="javascript:void(0)"
                        class="badge bg-soft-primary font-size-12"
                        v-b-tooltip.hover
                        v-if="value.transaction_remark"
                        @click="clickExtraInfo(`Transaction Remarks`, value, 'remark')"
                        >Remark <i class="uil uil-question-circle"></i></a
                      >
                    </td>
                    <td>
                      <span class="badge bg-soft-warning text-orange rounded-pill font-size-13" v-if="value.status =='reversed'" v-b-tooltip.hover
                        :title="value.reason">Reversed</span> 
                      <span
                        class="badge bg-soft-success rounded-pill font-size-13"
                        v-if="value.status == 'complete'"
                        >Completed</span
                      >
                      <span
                        class="badge bg-soft-danger rounded-pill font-size-13"
                        v-else-if="value.status == 'rejected'"
                        v-b-tooltip.hover
                        :title="value.reason"
                        >Rejected <i class="uil uil-question-circle"></i></span
                      >
                      <span class="badge bg-soft-info rounded-pill fw-medium font-size-13" v-else-if="value.status =='reserved'">Reserved
                      </span> 
                      <span class="badge bg-soft-warning rounded-pill fw-medium font-size-13" v-else-if="value.status =='pending'">Pending</span>
                    </td>
                    <td>
                      <span v-if="value.processed_by == 'system'"
                        >System</span
                      >
                      <span v-else>{{ value.processed_by || '-' }}</span>
                    </td>
                    <td>
                      <span v-if="create_modify_permission && account_type=='admin'">
                        <button class="btn btn-outline-info px-2 py-1 me-1 font-size-15 rounded" v-if="value.status =='complete'" @click="updateCallback(value, 'triggerCallback')" v-b-tooltip.hover title="Trigger Callback">
                        <i class="uil uil-exchange-alt"></i></button>

                        <button class="btn btn-outline-info px-2 py-1 me-1 font-size-15 rounded" @click="updateCallback(value,'triggerCallback')" v-b-tooltip.hover title="Trigger Callback" v-if="value.status =='rejected'">
                        <i class="uil uil-exchange-alt"></i></button>

                        <button class="btn btn-outline-info opacity-25 px-2 py-1 me-1 font-size-15 rounded" v-if="value.status =='pending'" v-b-tooltip.hover title="" disabled>
                        <i class="uil uil-exchange-alt"></i></button>

                        <button class="btn btn-outline-info opacity-25 px-2 py-1 me-1 font-size-15 rounded" v-if="value.status =='reserved'" v-b-tooltip.hover title="" disabled>
                        <i class="uil uil-exchange-alt"></i></button>

                        <button class="btn btn-outline-info px-2 py-1 me-1 font-size-15 rounded opacity-50" v-if="value.status =='reversed'" disabled="true">
                        <i class="uil uil-exchange-alt"></i></button>
                      </span>

                      <button class="btn btn-outline-info px-2 py-1 font-size-15 rounded" @click="clickExtraInfo(`Payout Detail #${value.payout_id }`, value)">
                      <i class="uil uil-eye"></i></button>

                      <span v-if="create_modify_permission && account_type=='admin'">
                        <button class="btn btn-outline-info px-2 py-1 me-1 font-size-15 rounded ms-1" v-if="value.status =='complete'" v-b-tooltip.hover.lefttop title="Reversal 冲正" @click="showRefund(value)" >
                          <i class="uil uil-arrow-up-left"></i>
                        </button>
                      </span>
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row" v-if="returnData.length && !loading">
              <div class="col mt-3">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      hide-ellipsis
                      @change="handlePageChange"
                      v-model="currentPage"
                      :per-page="perPage"
                      :total-rows="totalData"
                    >
                    </b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lottie
      :path="'/animate/loading_purple.json'"
      :title="'Loading'"
      :info="'Please wait...'"
      :show="showLottie"
      ref="lottieFunc"
    />
    <Common ref="commonFunc" />
    <MakePayout
      ref="modalFunc"
      :data="{ accessUsername: accessUsername, assessToken: accessToken }"
      @callParentFunction="handlePageChange(currentPage)"
    />
    <ImportPayout
      ref="modalFunc2"
      :data="{ accessUsername: accessUsername, assessToken: accessToken }"
      @callParentFunction="handlePageChange(currentPage)"
    />
    <extraInfo ref="modalFunc3" :data="{ extraInfo: currentClickedInfo }" />
    <updateCallback ref="modalFunc4" :data="{ accessUsername: accessUsername, assessToken: accessToken, updateData:updateData }"  @callParentFunction="handlePageChange(currentPage)"
    />
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Lottie from "@/components/lottieView";
import Common from "@/components/common";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import MakePayout from "@/views/pages/app/modal/createPayout";
import ImportPayout from "@/views/pages/app/modal/importPayout";
import extraInfo from "@/views/pages/app/modal/extraInfo";
import updateCallback from "@/views/pages/app/modal/updateCallback";

/**
 * Page
 */
const CancelToken = axios.CancelToken;
let cancel;

const PageTitle = "Payouts";
const usersDefault = {
  username: "",
  name: "All Users",
};
const pgDefault = {
  id: "",
  payment_gateway_name: "All Payment Gateway",
  payment_gateway_code: "",
  currency: "",
  status: "",
};
const CountryDefault = { name: "All Countries", value: "", status: "" };
const MerchantDefault = {
  status: "0",
  payin_rate: 0,
  contract_id: "",
  payout_rate: 0,
  total_payin: 0,
  ewallet_rate: 0,
  total_payout: 0,
  contract_name: "All Contracts",
  contract_total: 0,
  contract_status: "",
  settlement_rate: 0,
  contract_balance: 0,
  total_settlement: 0,
  contract_currency: "",
  payin_extra_charges: 0,
  payout_extra_charges: 0,
  ewallet_extra_charges: 0,
  settlement_extra_charges: 0,
  contract_list_length_total: 0,
  merchant_Id: "",
  account_name: "",
  merchant_status: "",
  reseller_id: "",
  reseller_name: "",
  reseller_code: "",
  reseller_level: 0,
};
export default {
  components: {
    Layout,
    PageHeader,
    Lottie,
    Common,
    DatePicker,
    Multiselect,
    MakePayout,
    ImportPayout,
    extraInfo,
    updateCallback
  },
  page() {
    return {
      title: PageTitle,
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    };
  },
  data() {
    return {
      currentClickedInfo: { title: "", info: {}, type: ""},
      accessToken: "",
      accessEmail: "",
      accessPhone: "",
      accessUsername: "",
      account_type: "",
      showLottie: false,
      title: "",
      items: [
        {
          text: appConfig.pageTitle,
          to: "/",
        },
        {
          text: "",
          active: true,
        },
      ],
      formData: {
        apiID: "YOUR_API_ID",
        apiHash: "YOUR_API_HASH",
      },
      submitted: false,
      loading: false,
      buttonLoading: [false, false, false],
      currentPage: 1,
      currencySymbol: "₹",
      selectedmerchantContract: MerchantDefault,
      merchantContract: [MerchantDefault],
      selectedCountry: CountryDefault,
      countryList: [CountryDefault],
      selectedPg: pgDefault,
      pgList: [pgDefault],
      selectedUsers: usersDefault,
      usersList: [usersDefault],
      seletedMethod: "",
      selectedStatus: "",
      searchPayoutId: "",
      searchReferenceNo: "",
      filterType: "created_date",
      searchAmount: "",
      searchTransactionId: "",
      perPage: 20,
      totalData: 0,
      returnData: [],
      returnPaidTotal: 0,
      returnPayoutProcessed: 0,
      export_data: [],
      search_value: "",
      disableExport: false,
      loadingButton: false,
      date_range: null,
      disable_date: false,
      disabled: false,
      shortcuts: [],
      extraInfo: {
        payment_gateway_name: "",
      },
      currentMerchantInfo:{},
      currentResellerInfo:{},
      create_modify_permission:false,
      updateData:{},
    };
  },
  middleware: "authentication",
  async mounted() {
    this.title = PageTitle;
    this.items[1].text = PageTitle;
    // this.$refs.main.changeVerticalTopBar("",true) *first value is back link and second is want set bg color?
    // this.$refs.main.changeVerticalTopBar("bill",true)
    // this.$refs.main.setShowFooterCert(false)
    // this.$refs.main.setPageTitle('title')
    await this.reload();
    this.accessToken = this.$refs.commonFunc.getToken();
    this.accessUsername = this.$refs.commonFunc.getUsername();
    this.date_range = this.$refs.commonFunc.last30Days();
    this.shortcuts = this.$refs.commonFunc.datePickerShortcut();
    this.getMerchantContract();
    this.getCountries();
    if (this.account_type =='admin'){
      this.getPgList()
    }
    if (this.account_type=='admin') {
      this.getUserList();
    }
    await this.handlePageChange(1);
  },
  created() {},
  methods: {
    showRefund(value) {
      this.updateData = value;
      setTimeout(() => this.$refs.modalFunc4.showRefund('payout'), 0);
    },
    updateCallback(value,type) {
       this.updateData = value;
       if(type=='triggerCallback'){
          setTimeout(() => this.$refs.modalFunc4.showTriggerCallbackModal('payout'), 0);
       }
       if(type=='trigger2success'){
          setTimeout(() => this.$refs.modalFunc4.showTrigger2successModal('payout'), 0);
       }
    },
    clickExtraInfo(title, object, type) {
      this.currentClickedInfo = { title: "", info: {}, type:"" };
      this.currentClickedInfo = { title: title, info: object, type: type};
      setTimeout(() => this.$refs.modalFunc3.showExtraInfoModal(), 0);
    },
    convertCurrencyFormat(value, show00) {
      if (show00 == true) {
        return this.$refs.commonFunc.convertCurrencyFormat(value);
      } else {
        // Assuming this.transactionLimit is defined in your component's data
        return this.$refs.commonFunc
          .convertCurrencyFormat(value)
          .replaceAll(".00", "");
      }
    },
    inputNumberOnly(event, parentModel) {
      const numericValue = event.target.value.replace(/[^0-9.]/g, "");
      this[parentModel] = numericValue;
    },
    countryChanged() {
      this.selectedPg = pgDefault;
      this.handlePageChange(1);
    },
    returnPgList() {
      if (this.selectedCountry.value !== "") {
        return this.pgList.filter(
          (element) => element.currency === this.selectedCountry.value
        );
      } else {
        return this.pgList;
      }
    },
    getPgList() {
      console.log("getPgList");
      this.$Progress.start();
      this.loading = true;
      this.disabled = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      axios({
        method: "post",
        url: appConfig.APIHostAdmin + "controller/admin/getPgListShort",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          var resData = response.data;
          if (resData.status == 200) {
            this.selectedPg = pgDefault;
            this.pgList = [this.selectedPg];
            resData.pg_list.forEach((element) => {
              this.pgList.push({
                id: element.id,
                payment_gateway_name: element.payment_gateway_name,
                payment_gateway_code: element.payment_gateway_code,
                currency: element.currency,
                status: element.status === "activated" ? 1 : 0,
              });
            });
          } else if (resData.status == 440) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
            localStorage.clear();
            this.$router.push({
              path: "/login",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
          }
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    async getCountries() {
      console.log("getCountries");
      this.$Progress.start();
      this.loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      axios({
        method: "post",
        url: appConfig.APIHostAdmin + "controller/admin/getSupportedCurrency",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          var resData = response.data;
          if (resData.status == 200) {
            (this.selectedCountry = CountryDefault),
              (this.countryList = [this.selectedCountry]);
            resData.data.forEach((element) => {
              this.countryList.push(element);
            });
          } else if (resData.status == 440) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
            localStorage.clear();
            this.$router.push({
              path: "/login",
            });
            this.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
            this.loading = false;
          }
          this.$Progress.finish();
        })
        .catch((error) => {
          this.loading = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    getMerchantContract() {
      console.log("getMerchantContract");
      this.$Progress.start();
      this.loading = true;
      this.disabled = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      bodyFormData.append("page", "1");
      bodyFormData.append("limit", "9999999");
      bodyFormData.append("reseller", (this.account_type==='reseller') ? this.currentResellerInfo.account_db_code : "all" ) 
      bodyFormData.append("merchant", (this.account_type==='merchant') ? this.currentMerchantInfo.account_db_code : "all" );
      axios({
        method: "post",
        url:
          appConfig.APIHostAdmin +
          "controller/admin/getContractListForMerchant",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          var resData = response.data;
          if (resData.status == 200) {
            this.selectedmerchantContract = MerchantDefault;
            this.merchantContract = [this.selectedmerchantContract];

            resData.data.forEach((element) => {
              this.merchantContract.push(element);
            });
          } else if (resData.status == 440) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
            localStorage.clear();
            this.$router.push({
              path: "/login",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
          }
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    getUserList() {
      console.log("getUserList");
      this.$Progress.start();
      this.loading = true;
      this.disabled = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      axios({
        method: "post",
        url: appConfig.APIHostAdmin + 'controller/admin/getAllUserList',
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          var resData = response.data;
          if (resData.status == 200) {
            this.selectedUsers = usersDefault;
            this.usersList = [this.selectedUsers];
            resData.data.forEach((element) => {
              this.usersList.push(element);
            });
          } else if (resData.status == 440) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
            localStorage.clear();
            this.$router.push({
              path: "/login",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              html: `${resData.message}.`,
              confirmButtonColor: "#222",
              confirmButtonText: this.$t("siteLang.Done"),
            });
          }
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.loading = false;
          this.disabled = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    notBeforeToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    DateChanged() {
      console.log("datechange" + this.date_range);
      this.handlePageChange(1);
      this.currentPage = 1;
      this.disable_date = true;
    },
    handlePageChange(current_page) {
      this.pageNum = current_page;
      this.currentPage = current_page;
      this.getData(this.pageNum, this.search_value);
      //this.exportData(1)
    },

    search() {
      this.handlePageChange(1);
      this.currentPage = 1;
    },
    clear() {
      this.selectedCountry = CountryDefault;
      this.selectedmerchantContract = MerchantDefault;
      this.selectedPg = pgDefault;
      this.seletedMethod = "";
      this.selectedStatus = "";
      this.searchPayoutId = "";
      this.searchReferenceNo = "";
      this.filterType = "created_date";
      this.searchAmount = "";
      this.searchTransactionId = "";
      this.date_range = this.$refs.commonFunc.last30Days();

      this.search_value = "";
      this.handlePageChange(1);
      this.currentPage = 1;
    },

    exportToExcel(Data, name, type) {
      var title = name.replace(/ /g, "_");
      var ws = window.XLSX.utils.json_to_sheet(Data);
      let objectMaxLength = [];
      for (let i = 0; i < Data.length; i++) {
        let value = Object.values(Data[i]);
        for (let j = 0; j < value.length; j++) {
          if (typeof value[j] == "number") {
            objectMaxLength[j] = 5;
          } else {
            objectMaxLength[j] =
              objectMaxLength[j] >= value[j].length
                ? parseInt(objectMaxLength[j])
                : parseInt(value[j].length) + 5;
          }
        }
      }
      var wscols = [];
      objectMaxLength.forEach((value, index) => {
        console.log(value);
        wscols.push({ width: objectMaxLength[index] });
      }),
        (ws["!cols"] = wscols);

      var wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, name);
      window.XLSX.writeFile(wb, title + "." + (type || "xlsx"));
    },
    async getData(pages, keyword) {
      if (cancel !== undefined) cancel();
      this.$Progress.start();
      this.loading = true;
      this.disabled = true;
      this.disable_date = true;
      this.returnData = [];
      var bodyFormData = new FormData();

      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("accessUsername", this.accessUsername);
      bodyFormData.append("page", pages);
      bodyFormData.append("limit", this.perPage);
      bodyFormData.append("status", this.selectedStatus);
      bodyFormData.append("processBy", this.selectedUsers.username);
      bodyFormData.append("dateStart", this.date_range[0]);
      bodyFormData.append("dateEnd", this.date_range[1]);
      bodyFormData.append("merchantContractId", this.selectedmerchantContract.contract_id);
      bodyFormData.append("payoutId", this.searchPayoutId);
      bodyFormData.append("currency", this.selectedCountry.value);
      bodyFormData.append("referenceId", this.searchReferenceNo);
      bodyFormData.append("transactionId", this.searchTransactionId);
      bodyFormData.append("amount", this.searchAmount);

      console.log(
        this.selectedmerchantContract.contract_id,
        this.seletedMethod,
        this.selectedStatus,
        keyword,
        this.selectedCountry.value,
        this.selectedPg.payment_gateway_code,
        this.searchTransactionId,
        this.searchReferenceNo,
        this.searchAmount,
        this.filterType,
        this.date_range[0],
        this.date_range[1]
      );
      axios({
        method: "post",
        url: appConfig.APIHostAdmin + 'controller/admin/getAllPayoutList',
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
        cancelToken: new CancelToken((c) => (cancel = c)),
      })
        .then((response) => {
          var resData = response.data;
          if (resData.status == 200) {
            this.returnData = [];
            this.returnData = resData.data;
            this.returnPaidTotal = resData.paid_total;
            this.returnPayoutProcessed = resData.authorised_total;
            this.totalData = resData.total;
          }
          else if (resData.status == 440){
            Swal.fire(
                {
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
              localStorage.clear();
              this.$router.push({
                  path: "/login",
              });
          }
          else {
              Swal.fire(
                {
                icon: 'error',
                title: 'Oops...',
                html: `${resData.message}.`,
                confirmButtonColor: '#222',
                confirmButtonText: this.$t('siteLang.Done'),
              })
          }
          this.loading = false;
          this.disabled = false;
          this.disable_date = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.loading = false;
          this.disabled = false;
          this.disable_date = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    async exportData() {
      this.$Progress.start();
      this.disableExport = true;
      this.loadingButton = true;
      var bodyFormData = new FormData();
      bodyFormData.append("accessToken", this.accessToken);
      bodyFormData.append("phone", this.accessPhone);
      // bodyFormData.append("page", pages);
      // bodyFormData.append("limit", this.perPage);
      axios({
        method: "get",
        url: `https://dummyjson.com/users/search?q=&limit=100&skip=1`,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          this.export_data = [];
          var resData = response.data;
          this.totalData = resData.total;
          var users = resData.users;

          for (var i in users) {
            // Combine date and time
            const depositDateTime = `29 Jun 2023, 12:30:00`;
            // Generate a random deposit amount
            const randomDeposit = Math.floor(Math.random() * 10000) + 1000; // Random amount between 1000 and 11000

            // Calculate merchant fee and nett amount
            const merchantFeePercentage = 2.5 / 100; // 2.5% merchant fee
            const merchantFee = Math.floor(
              randomDeposit * merchantFeePercentage
            );
            const nettAmount = randomDeposit - merchantFee;
            const randomStatus = Math.random() < 0.8 ? "success" : "failed";
            var randomMode = Math.random() < 0.8 ? "UPI" : "IMPS";
            var transaction_id = "";
            if (randomMode == "UPI") {
              transaction_id = "320020673657";
            } else {
              transaction_id = "IMPS/123443211240";
            }

            const listData = {
              id: "ids",
              deposit_date: depositDateTime,
              customer_id: `${users[i].id}`,
              customer_name: `${users[i].firstName} ${users[i].lastName}`,
              deposit_amount: randomDeposit.toString(),
              deposit_mode: randomMode.toString(),
              merchant_fee: merchantFee.toString(),
              nett_amount: nettAmount.toString(),
              transaction_id: transaction_id,
              status: randomStatus,
            };
            this.export_data.splice(i, 0, listData);
          }
          var self = this;
          setTimeout(function () {
            self.disableExport = false;
            self.loadingButton = false;
            self.exportToExcel(self.export_data, "Summary", "xlsx");
          }, 1200);

          // if (resData.status == 200) {
          //   console.log(resData)
          //   this.totalData = 10
          // }
          // else if (resData.status == 440){
          //   Swal.fire(
          //       {
          //       icon: 'error',
          //       title: 'Oops...',
          //       html: `${resData.message}.`,
          //       confirmButtonColor: '#222',
          //       confirmButtonText: this.$t('siteLang.Done'),
          //     })
          //     localStorage.clear();
          //     this.$router.push({
          //         path: "/login",
          //   });
          // }
          // else {
          //     Swal.fire(
          //       {
          //       icon: 'error',
          //       title: 'Oops...',
          //       html: `${resData.message}.`,
          //       confirmButtonColor: '#222',
          //       confirmButtonText: this.$t('siteLang.Done'),
          //     })
          // }
          this.loading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.disableExport = false;
          this.loadingButton = false;
          this.loading = false;
          this.$Progress.finish();
          //Swal.fire("Error", error, "error");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: `${error}.`,
            confirmButtonColor: "#222",
            confirmButtonText: this.$t("siteLang.Done"),
          });
        });
    },
    async reload() {
      try {
        await this.$nextTick(); // Wait for the component to be fully mounted

        const commonFunc = this.$refs.commonFunc;
        if (commonFunc && commonFunc.getFullData) {
          const data = await commonFunc.getFullData();
          this.currentMerchantInfo = data.merchant_info;
          this.currentResellerInfo = data.reseller_info;
          this.account_type = data.account_type; //data.account_type;
          const permission = data.modules.filter(e => e.name==='payout')
          if (permission) {
            this.create_modify_permission = permission[0].create_modify_permission==0 ? false : true; 
            console.log(this.create_modify_permission)
          } else {
            console.log('Module with name "payout" not found.');
          }
        } else {
          // Handle the case when commonFunc or getFullData is undefined
          // Perform appropriate actions or show a fallback message to the user
        }
      } catch (error) {
        // Handle the error silently without propagating it further
      }
    },
  },
};
</script>
